import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { accountOperation } from './request';
import { structureList, accountDetail } from './../../customer/accountManage/request';
import { roleResource } from '@/api/roleManage';
import structureModel from './../../customer/accountManage/structureModel.vue';
import { mapState } from 'vuex';
export default {
  components: {
    structureModel
  },
  data() {
    return {
      uesrInfo: {},
      form: {
        roleIds: '',
        nickName: '',
        mobile: '',
        customerId: this.$route.params.customerId,
        structureId: undefined,
        account: '',
        email: '',
        globalRoaming: '+86'
      },
      value: '',
      nickName: '',
      roleList: [],
      treeData: [],
      treeSource: [],
      structureShow: false,
      globalRoamingOptionData: [{
        label: '+86',
        value: '中国大陆',
        code: 'CN'
      }, {
        label: '+886',
        value: '中国台湾',
        code: 'TW'
      }, {
        label: '+852',
        value: '中国香港',
        code: 'HK'
      }, {
        label: '+853',
        value: '中国澳门',
        code: 'MO'
      }, {
        label: '+1',
        value: '美国',
        code: 'US'
      }, {
        label: '+65',
        value: '新加坡',
        code: 'SG'
      }]
    };
  },
  computed: {
    rules() {
      if (this.$route.params.id == -1) {
        return {
          nickName: [{
            required: true,
            message: this.$t('请输入') + this.$t('名称'),
            trigger: 'blur'
          }, {
            min: 1,
            max: 100,
            message: this.$t('长度应最少一位,最多一百位'),
            trigger: 'blur'
          }],
          mobile: [{
            required: true,
            trigger: 'blur',
            validator: this.validatePhone
          }],
          roleIds: [{
            required: true,
            message: this.$t('请至少选择一个角色'),
            trigger: 'change'
          }],
          structureId: [{
            required: true,
            message: this.$t('请至少选择一个架构'),
            trigger: 'change'
          }],
          account: [{
            required: true,
            message: this.$t('请输入') + this.$t('管理员账号'),
            trigger: 'blur'
          }, {
            pattern: /^[a-zA-Z0-9@.]+$/,
            message: this.$t('仅限输入大小写字母、数字、特殊符号“@”和“.”'),
            trigger: 'blur'
          }, {
            min: 8,
            max: 50,
            message: this.$t('请输入8-50字符'),
            trigger: 'blur'
          }],
          password: [{
            required: true,
            message: this.$t('请输入') + this.$t('登录密码'),
            trigger: 'blur'
          }, {
            min: 8,
            max: 16,
            message: this.$t('请输入8-16位数字、大小写字母组合'),
            trigger: 'blur'
          }, {
            pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9]{8,16}$/,
            message: this.$t('请输入8-16位数字、大小写字母组合'),
            trigger: 'blur'
          }],
          email: [{
            required: false,
            validator: this.checkEmail,
            trigger: 'blur'
          }]
        };
      } else {
        return {
          nickName: [{
            required: true,
            message: this.$t('请输入') + this.$t('名称'),
            trigger: 'blur'
          }, {
            min: 1,
            max: 100,
            message: this.$t('长度应最少一位,最多一百位'),
            trigger: 'blur'
          }],
          mobile: [{
            required: true,
            trigger: 'blur',
            validator: this.validatePhone
          }],
          roleIds: [{
            required: true,
            message: this.$t('请至少选择一个角色'),
            trigger: 'change'
          }],
          structureId: [{
            required: true,
            message: this.$t('请至少选择一个架构'),
            trigger: 'change'
          }],
          account: [{
            required: true,
            message: this.$t('请输入') + this.$t('管理员账号'),
            trigger: 'blur'
          }, {
            pattern: /^[a-zA-Z0-9@.]+$/,
            message: this.$t('仅限输入大小写字母、数字、特殊符号“@”和“.”'),
            trigger: 'blur'
          }, {
            min: 8,
            max: 50,
            message: this.$t('请输入8-50字符'),
            trigger: 'blur'
          }],
          password: [{
            min: 8,
            max: 16,
            message: this.$t('请输入8-16位数字、大小写字母组合'),
            trigger: 'blur'
          }, {
            pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9]{8,16}$/,
            message: this.$t('请输入8-16位数字、大小写字母组合'),
            trigger: 'blur'
          }],
          email: [{
            required: false,
            validator: this.checkEmail,
            trigger: 'blur'
          }]
        };
      }
    },
    ...mapState({
      accountInfo: state => state.user.accountInfo
    })
  },
  async created() {
    console.log(this.$route.params.id, 'this.$route.params.id', this.accountInfo);
    if (this.$route.params.id == -1) {
      let globalRoaming = sessionStorage.getItem('globalRoaming') || '+86';
      this.$set(this.form, 'globalRoaming', globalRoaming);
    }
    await roleResource({
      userId: this.$route.params.id != -1 ? this.$route.params.id : '',
      customerId: this.form.customerId
    }).then(res3 => {
      this.roleList = res3;
      res3.map(item => {
        if (item.selected) {
          this.form.roleIds = item.id;
        }
      });
    });
    await structureList({
      customerId: this.form.customerId
    }).then(res => {
      console.log(res, '---------111-------');
      this.treeData = res[0].children || [];
      this.treeSource = res;
    });
    if (this.$route.params.id != -1) {
      await accountDetail({
        userId: this.$route.params.id
      }).then(res2 => {
        console.log(res2, 111);
        this.uesrInfo = res2;
        this.form.userId = this.$route.params.id;
        this.form.nickName = res2.nickName;
        this.form.mobile = res2.mobile;
        this.form.structureId = res2.structureId || '';
        this.form.account = res2.account;
        this.form.email = res2.email;
        this.form.globalRoaming = res2.globalRoaming || '+86';
      });
    }
  },
  methods: {
    checkEmail(rule, value, callback) {
      let regEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (value && !regEmail.test(value)) {
        callback(new Error(this.$t('邮箱有误，请重新填写')));
      } else {
        callback();
      }
    },
    handleBlurTrim(key) {
      this.form[key] = this.form[key].trim();
    },
    validateAccount(rule, value, callback) {
      let reg = /^[\w@.\-_]+$/;
      if (value.trim().length === 0) {
        callback(new Error(this.$t('用户名不能为空')));
      } else if (!reg.test(value)) {
        callback(new Error(this.$t('仅限输入大小写字母、数字或特殊字符“@”和“.”“-”“_”')));
      } else {
        callback();
      }
    },
    validatePhone(rule, value, callback) {
      const regMap = {
        CN: /^1[3456789]\d{9}$/,
        // 中国
        TW: /^09\d{8}$/,
        // +886台湾
        HK: /^([6|9])\d{7}$/,
        // +852香港
        MO: /^[6]\d{7}$/,
        // +853澳门
        US: /^[1-9]\d{9}$/,
        // +1美国
        SG: /^[89]\d{7}$/ // +65新加坡
      };
      let findItem = this.globalRoamingOptionData.find(item => item.label === this.form.globalRoaming);
      if (findItem && findItem.length === 0) {
        callback();
      }
      let regValue = regMap[findItem.code];
      if (!value) {
        callback(new Error(this.$t('请输入') + this.$t('手机号')));
      } else if (!regValue.test(value)) {
        callback(new Error(this.$t('手机号码格式有误，请重新填写')));
      } else {
        callback();
      }
    },
    getStructureFun(val) {
      console.log(val);
      structureList({
        customerId: this.form.customerId
      }).then(res => {
        this.treeData = res[0].children || [];
        setInterval(() => {
          this.structureId = val;
          this.form.structureId = val;
        }, 200);
      });
    },
    checkboxChange(val) {
      console.log(val);
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          accountOperation(this.form).then(async res => {
            // 判断用户信息是不是当前账号的，是就更新用户信息
            if (this.$route.params.id == this.accountInfo.id && this.$route.params.customerId == this.accountInfo.customerId) {
              // 重新获取用户信息
              await this.$store.dispatch('user/getInfo');
            }
            this.$message.success(this.$t('操作成功') + '!');
            this.$router.go(-1);
          });
        }
      });
    },
    onChange(value) {
      console.log(value);
      this.form.structureId = value;
    },
    filterTreeOption(input, treeNode) {
      return treeNode.data.props.title.includes(input);
    },
    addStructureFun() {
      this.structureShow = true;
      this.$nextTick(() => {
        this.$refs.structureRef.init(this.treeSource);
      });
    },
    changeGlobalRoaming() {
      this.$set(this.form, 'mobile', '');
    }
  }
};